import { ISelectItem } from "@/types";
import {
  IPartner,
  IPartnerCreateRequest,
  IPartnerListRequest,
  IPartnerRequest,
  IPartnerUpdateRequest,
} from "@/types/partner";
import { ListRequest } from "./listRequest";

export class Partner implements IPartner {
  public id = 0;
  public name = "";
  public uniqueid = "";
  public email = "";
  public tel = "";
  public address = "";
  public cutoff_date = "";
  public company_id = 0;
  public created_at = "";
  public updated_at = "";

  public constructor(props?: IPartner) {
    if (!props) {
      return;
    }
    Object.assign(this, props);
  }

  public static toSelectItem(partner: IPartner): ISelectItem {
    return {
      text: partner.name,
      value: partner.id,
    };
  }
}

export class PartnerRequest implements IPartnerRequest {
  public name = "";
  public uniqueid = "";
  public email = "";
  public tel = "";
  public address = "";
  public cutoff_date = "";
  public progress: string[] = [];
  [key: string]: unknown;

  // public constructor() {}
}

export class PartnerCreateRequest
  extends PartnerRequest
  implements IPartnerCreateRequest {}

export class PartnerUpdateRequest
  extends PartnerRequest
  implements IPartnerUpdateRequest
{
  public id = 0;

  public constructor(props?: IPartner) {
    super();

    if (!props) {
      return;
    }

    Object.assign(this, props);
    if (props.progress) {
      this.progress = props.progress.map((item) => item.name);
    }
  }
}

export class PartnerListRequest
  extends ListRequest
  implements IPartnerListRequest {}
